<template>
  <div class="edc-form-bar">
    <table class="status-table">
      <thead>
        <tr class="activity-status-border">
          <th class="md-2"></th>
          <th class="heading color-gray fs-12 pl-10">Approval Status</th>
          <th class="heading color-gray fs-12">Verification Status</th>
          <th class="heading color-gray fs-12">Signed Off Status</th>
          <th class="heading color-gray fs-12">Review Status</th>
          <th class="heading color-gray fs-12 span-48">Locked Status</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="md-2"></td>
          <td class="text-left pt-15 pb-15 pl-10">
            <span v-if="(canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canCallCenterAccess || canSiteDataLockAccess) && !user.readOnly && edcFormInfo.lockStatus === 'UNLOCKED'" class="active-text fs-14" @click="openApproveModal()">{{ approvalStatusText[edcFormInfo.approvalStatus] }}</span>
            <span v-else class="status-text color-gray-100 fs-14">{{ approvalStatusText[edcFormInfo.approvalStatus] }}</span>
          </td>
          <td class="text-left pt-15 pb-15">
            <span v-if="(canCraAccess || canCraUBAccess) && edcFormInfo.lockStatus === 'UNLOCKED'" class="active-text fs-14" @click="openVerificationModal()">{{ verificationStatusText[edcFormInfo.verificationStatus] }}</span>
            <span v-else class="status-text color-gray-100 fs-14">{{ verificationStatusText[edcFormInfo.verificationStatus] }}</span>
          </td>
          <td class="text-left pt-15 pb-15">
            <span v-if="canPiAccess && verified() && approved() && edcFormInfo.lockStatus === 'UNLOCKED'" class="active-text fs-14" @click="openSignoffModal()">{{ signoffStatusText[edcFormInfo.signoffStatus] }}</span>
            <span v-else class="status-text color-gray-100 fs-14">{{ signoffStatusText[edcFormInfo.signoffStatus] }}</span>
          </td>
          <td class="text-left pt-15 pb-15">
            <span v-if="(canCraAccess || canDmAccess || canCraUBAccess) && edcFormInfo.lockStatus === 'UNLOCKED'" class="active-text fs-14" @click="openReviewModal()">{{ reviewStatusText[edcFormInfo.reviewStatus] }}</span>
            <span v-else class="status-text color-gray-100 fs-14">{{ reviewStatusText[edcFormInfo.reviewStatus] }}</span>
          </td>
          <td class="text-left pt-15 pb-15 span-48">
            <span v-if="canCraAccess || canDmAccess || canCraUBAccess" class="active-text fs-14" :class="{ disabled: disableActvityLockUnlockBtn }" @click="openLockModal()">{{ lockStatusText[edcFormInfo.lockStatus] }}</span>
            <span v-else class="status-text color-gray-100 fs-14">{{ lockStatusText[edcFormInfo.lockStatus] }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { AclRule } from "vue-acl";
import { mapGetters } from "vuex";
import UserAccesses from "@/mixins/user-accesses";
import { approvalStatusText, verificationStatusText, reviewStatusText, lockStatusText, signoffStatusText, signoffStatus, reviewStatus, lockStatus, verificationStatus, approvalStatus } from "@/constants/form";

export default {
  name: "form-info",
  components: {},
  mixins: [UserAccesses],
  props: {
    edcFormInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      approvalStatusText,
      verificationStatusText,
      verificationStatus,
      reviewStatusText,
      lockStatusText,
      signoffStatusText,
      signoffStatus,
      reviewStatus,
      lockStatus,
      disableActvityLockUnlockBtn : false
    };
  },
  computed: {
    ...mapGetters(["user"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    }
  },
  methods: {
    verified() {
      return this.edcFormInfo.verificationStatus === verificationStatus.VERIFIED;
    },
    approved() {
      return this.edcFormInfo.approvalStatus === approvalStatus.APPROVED;
    },
    openApproveModal() {
      this.$emit("openApprovalModal");
    },
    openVerificationModal() {
      this.$emit("openVerificationModal");
    },
    openReviewModal() {
      this.$emit("openReviewModal");
    },
    openLockModal() {
      if (!this.disableActvityLockUnlockBtn) {
        this.$emit("openLockModal");
      }
    },
    openSignoffModal() {
      this.$emit("openSignoffModal");
    },
    disableActvityLockUnlockStatus() {
      let dataString = localStorage.getItem('thread-userObj');
      let userDetails = JSON.parse(dataString);
      if(userDetails.restrictions && (userDetails.restrictions.includes('activity_response.lock') || userDetails.restrictions.includes('activity_response.unlock'))){
        this.disableActvityLockUnlockBtn = true;
      }
      else{
        this.disableActvityLockUnlockBtn = false;
      }
    }
  },
  mounted(){
    this.disableActvityLockUnlockStatus()
  },
};
</script>

<style scoped lang="scss">
.edc-form-bar {
  background-color: #fff;
  padding: 10px 0px 0px;
  -webkit-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.06);
  margin-top: 15px;
  .heading {
    font-weight: 600;
  }
  table {
    border-bottom: 2px solid #bfbfbf;
  }
}
.date {
  font-size: 12px;
  line-height: 1.67;
}
.telehealth-call {
  .heading {
    font-size: 10px;
  }
  .value {
    font-size: 10px;
  }
}
.status-text {
  font-size: 15px;
  font-family: "RobotoRegular";
  color: #4a4a4a;
  text-align: left;
}
.active-text {
  font-size: 15px;
  font-family: "RobotoRegular";
  color: #4c8ce4;
  cursor: pointer;
  text-align: left;

  &.disabled {
    cursor: no-drop;
    color: #a4a4a4;
  }
  
}
table {
  width: 100%;
  .activity-status-border {
    height: 30px;
  }

  &.status-table {
    display: flex;
    flex-direction: column;
  }

  tr {
    display: flex;
    flex: 1;
    align-items: center;

    td,
    th {
      flex: 6;

      &.md-2 {
        flex: 12;
      }
      &.span-48 {
        flex: 12 48px;
      }

      @media (max-width: 768px) {
        &.md-2 {
          flex: 6;
        }
        &.span-48 {
          flex: 6;
        }
      }
    }
  }
}
.color-gray {
  color: #9b9b9b;
}

.color-gray-100 {
  color: #a4a4a4;
}
table thead {
  background: #f9f9fb;
}
table thead th {
  vertical-align: middle;
}
</style>
